/**
 * WhatsApp-Kontakt (schwebender Button „Kurze Frage?“).
 *
 * Die Nummer steht nicht im Code, sondern in `app_settings` unter
 * WHATSAPP_SETTING_KEY und ist im Admin unter Kontakte → WhatsApp änderbar
 * (z. B. für Urlaubsvertretungen). Ohne gültige Nummer erscheint kein Button.
 */

export const WHATSAPP_SETTING_KEY = "whatsapp_kontakt_nummer";
export const WHATSAPP_SETTING_LABEL = "WhatsApp-Nummer für „Kurze Frage?“";

/** Vorausgefüllter Text im Chat; zeigt zugleich, dass die Nachricht von der Website kommt. */
export const WHATSAPP_START_TEXT = "Hallo creategy, ich habe eine kurze Frage:";

/**
 * Nummer in die Form für wa.me bringen: nur Ziffern, Ländervorwahl ohne „+“.
 * „0170…“ wird als deutsche Nummer gelesen (49170…). Ungültig = null.
 */
export function normalizeWhatsAppNumber(input: string | null | undefined): string | null {
  if (!input) return null;
  let digits = input
    .trim()
    .replace(/^\+/, "")
    .replace(/^00/, "")
    .replace(/[\s()/.-]/g, "");
  if (!/^\d+$/.test(digits)) return null;
  if (digits.startsWith("0")) digits = `49${digits.slice(1)}`;
  return digits.length >= 8 && digits.length <= 15 ? digits : null;
}

/** Lesbare Form für die Anzeige im Admin, z. B. „+49 1701234567“. */
export function formatWhatsAppNumber(digits: string): string {
  return digits.startsWith("49") ? `+49 ${digits.slice(2)}` : `+${digits}`;
}

/** Chat-Link mit Starttext. Öffnet am Handy die App, am Computer Desktop-App oder WhatsApp Web. */
export function whatsAppChatUrl(digits: string, text: string = WHATSAPP_START_TEXT): string {
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

/** Seiten ohne schwebenden Button (wie vorher beim Terminbutton). */
export const WHATSAPP_HIDDEN_PATHS = [
  "/kontakt",
  "/kontakt/danke",
  "/termin",
  "/termin/danke-email",
  "/mentoring/danke",
];

export function isWhatsAppHiddenPath(pathname: string): boolean {
  return WHATSAPP_HIDDEN_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
